import React from "react";
import { WalletContext } from "../../contexts/Wallet";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function Header() {
    const wallet = React.useContext(WalletContext);

    return (
        <header className="header">
            <Box sx={{display: "flex", flexDirection: ["column", "column", "row"], justifyContent: ["center", "center", "space-between"], alignItems: ["center", "center", "start"]}}>
            <a style={{textDecoration: "none", fontSize: "24px", lineHeight: "40px"}} href="/">
                <b style={{color: "black"}}>Book</b><span style={{color: "#5a9d5c"}}>NFT</span>
            </a>
            {
            !wallet.chainNetwork.account.address?(<Box><Button sx={{padding: ["5px 15px", "5px 45px"], background: "#d9d9d9", color: "black"}} variant="outlined" onClick={()=>wallet.chainNetwork.onWalletChange()}>Connect Your Wallet</Button></Box>):
			<Box>{"Wallet: " + wallet.chainNetwork.account.address.substring(0, 7) +
            "..." +
            wallet.chainNetwork.account.address.substring(
                wallet.chainNetwork.account.address.length - 4
            )}</Box>          
            }
            </Box>
        </header>
    )
}